export default "__VITE_ASSET__DItapB4d__"